<template>
  <div style="background:#fff">
    <wh-popup-select
      v-model="name"
      :rules="rules"
      :label="lable"
      :placeholder="placeholder"
      name="landAreaUnit"
      :columns="staffList"
      @change="inputChange"
    >
      <template #right-icon>
        <span class="checkList">选择</span>
      </template>
    </wh-popup-select>
  </div>
</template>
<script>
import api from '@/api'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'

export default {
  components: { WhPopupSelect },
  model: {
    prop: 'selectname',
    event: 'change'
  },
  props: {
    lable: {
      type: String,
      default: 'lable'
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    selectname: {
      type: [String, Boolean, Number],
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data() {
    return {
      name: '',
      staffList: []
    }
  },
  watch: {
    selectname: {
      handler(newV) {
        this.name = newV
      },
      immediate: true
    }
  },
  mounted() {
    this.getStaffList()
  },

  methods: {
    inputChange(val) {
      this.$emit('change', val)
    },
    getStaffList() {
      api.getStaffList().then(res => {
        res.data.list.map(item => {
          this.staffList.push(
            {
              text: item.name,
              value: item.name
            }
          )
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.checkList{
    width: 35px;
    font-size: 14px;
    color: #20CAA0;
  }
</style>
